
import { ApiModule } from '@api/src/ApiModule'

import createNumberMask from 'text-mask-addons/dist/createNumberMask'

export class Mask extends ApiModule {
  constructor(props) {
    super(props)
  }

  get currency() {
    return createNumberMask({
      prefix: '$',
      allowDecimal: true,
      includeThousandsSeparator: true,
      allowNegative: false
    })
  }
}
